import {
    Box,
    HStack,
    Image,
    Step,
    StepDescription,
    StepIndicator,
    StepSeparator,
    StepStatus,
    StepTitle,
    Stepper,
    Text,
    Textarea,
    Flex,
  } from "@chakra-ui/react";
  import React, { useEffect, useRef, useState } from "react";
  import { FetchPhysicalExamDetails, FetchSocialHistoryDetails, UpdatePhysicalExam } from "../../middleware/services/messages";
  import moment from "moment";
  import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import { useLocation } from "react-router-dom";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import { useScreenType } from "../../auth";
import { wrap } from "framer-motion";
import { DropdownInput, PrimaryButton, PrimaryInput, Toaster } from "../../components";
import { FetchDoctorsByUser, FetchUsersByClinic } from "../../middleware/services/home";
import AssessmentAudioManager from "../../components/patient-health/doctor-notes/assessmentaudiomanager";
import DatePicker from "../../components/date-picker";
import DynamicModal from "../../components/dynamic-modal";
import { format } from "date-fns";
import { ChatAudioManager } from "../../components/generic-chatbot/audio/chatVoiceManager";
import { useTranscriber } from "../../components/generic-chatbot/audio/useTranscriber";
import { CorrectChiefComplaintUsingAI, CorrectMedicalTermsUsingAI } from "../../middleware/services/visits/aicalls";
import { useForm } from "react-hook-form";
import { GPUChatAudioManager } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/gpuChatVoiceManager";
import { useGPUTranscriber } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/useGPUTranscriber";
import { useHybridTranscriber } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/useHybridTranscriber";
import { GPUChatAudioManagerSpeechMode } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/gpuChatVoiceManagerSpeechMode";
import { languageCodeMap, languageOptions } from "../../components/language-dropdown";
import DropdownWithMultiLingual from "../../components/dropdown-multilingual";
import { AudioDisplayForClutter } from "../../components/patient-health/doctor-notes/notes-transcription/utils/audio-display-multi-lingual";


const PhysicalExam = ({id,backFunction,doctorId,appointmentid}) => {

      const location = useLocation();
      const [patientid, setPatientid] = useState("");
      const [physicalExamData, setPhysicalExamData] = useState(null);
      const { isLoading, showLoader, dismissLoader } = useLoader();
      const screenType = useScreenType()
      const addPhysicalRef = React.useRef(null);
      const editPhysicalRef = React.useRef(null);
      const deletePhysicalRef = React.useRef(null);
      const aiModifiedRef = React.useRef(false);
      const [date, setDate] = useState(moment().format("DD-MM-yyyy"));
      const [time, setTime] = useState(moment().format("HH:mm"));
      const { showSuccessToast, showErrorToast } = Toaster();
      var [DoctorList, setDoctorList] = useState([]);
      var [doctorData, setDoctorData] = useState([]);
      var [DefaultDoctor, setDefaultDoctor] = useState(null);
      const [formInputs, setFormInputs] = useState([
        { type: null, physicalexamtext: "", id: null, updateddate: "" },
      ]);

  // waves 
    //  const recorderRef = useRef(null);
    //    const [chunks, setChunks] = useState([]);
    //      const [recording, setRecording] = useState(false);
       
    //   const [stream, setStream] = useState(null);
  
    //   useEffect(() => {
    //       if (recorderRef.current) return;
      
    //       if (navigator.mediaDevices.getUserMedia) {
    //         navigator.mediaDevices
    //           .getUserMedia({ audio: true })
    //           .then((stream) => {
    //             setStream(stream);
      
    //             recorderRef.current = new MediaRecorder(stream);
    //             // audioContextRef.current = new AudioContext({
    //             //   sampleRate: WHISPER_SAMPLING_RATE,
    //             // });
      
    //             recorderRef.current.onstart = () => {
    //               setRecording(true);
    //               setChunks([]);
    //             };
    //             recorderRef.current.ondataavailable = (e) => {
    //               if (e.data.size > 0) {
    //                 setChunks((prev) => [...prev, e.data]);
    //               } else {
    //                 setTimeout(() => {
    //                   recorderRef.current.requestData();
    //                 }, 25);
    //               }
    //             };
      
    //             recorderRef.current.onstop = () => {
    //               setRecording(false);
    //             };
    //           })
    //           .catch((err) => console.error("The following error occurred: ", err));
    //       } else {
    //         console.error("getUserMedia not supported on your browser!");
    //       }
      
    //       return () => {
    //         recorderRef.current?.stop();
    //         recorderRef.current = null;
    //       };
    //     }, []);
      
  
    // // ------------------------------------
    // //Remove speech and keep Null to toggle between GPU and Speech
    // const [SelectedLanguage, setSelectedLanguage] = useState("en-US");
    // const [inpLang, setInpLang] = useState("English");
    
    // const handleChangeLanguage = (selectedOption) => {
    //   const selectedLanguage = selectedOption.value; // Get the selected language
    //   setInpLang(selectedLanguage)
    //   const languageCode = languageCodeMap[selectedLanguage] || "en-US"; // Default to English (US) if not found
  
    //   // Update the language in the transcriber
    //   setSelectedLanguage(languageCode);
    //   console.log("Selected Language: ", selectedLanguage);
    //   console.log("Language Code: ", languageCode);
    // };
  
    // const [outLang, setOutputLang] = useState("English")
    // const handleChangeOutputLanguage = (selectedOption) => {
    //   const selectedLanguage = selectedOption.value; 
    //   // const languageCode = languageCodeMap[selectedLanguage] || "en-US"; 
  
    //   // Update the language in the transcriber
    //   setOutputLang(selectedLanguage);
    //   console.log("Selected Language OUTPUT: ", selectedLanguage);
    //   // console.log("Language Code OUTPUT: ", languageCode);
    // };

    // // Add this state to your parent component
    // const [isRecording, setIsRecording] = useState(false);
    
    // // Add this function to handle recording state changes
    // const handleRecordingStateChange = (recording) => {
    //   setIsRecording(recording);
    // };

      //const activeTranscriber = useGPUTranscriber();
      //Remove speech and keep Null to toggle between GPU and Speech
      const { transcriber: activeTranscriber, mode } =
        useHybridTranscriber("speech", (text) => {
          // called when speech recognition finishes
          setPlaceholder(text || "");
          setTyping(false);
      }
    //   ,
    // SelectedLanguage
  );
      const [typing, setTyping] = useState(false);
      const [isDateChanged, setIsDateChanged] = useState(false);
    
      const [placeholder, setPlaceholder] = useState(
        "Click anywhere to start typing...."
      );

      // const [textFieldValue, setTextFieldValue] = useState(""); 
      const [defaultText, setDefaultText] = useState("");
      const [deleteId, setDeleteId] = useState(null);

      // useEffect(() => {
      //   // console.log("triggered");
      //   if (activeTranscriber?.output?.text) {
      //     setTextFieldValue(activeTranscriber.output.text);
      //     setDefaultText(activeTranscriber.output.text);
      //     setPlaceholder("Click anywhere to start typing....");
      //     setTyping(false);
      //   }
      // }, [activeTranscriber?.output]);

      useEffect(() => {
        const currentUrl = window.location.href;
        const searchParams = new URLSearchParams(currentUrl.split('?') [1]);
        const id = searchParams.get('id');
        setPatientid(id);
        if (appointmentid) {
          fetchexamdata(id,appointmentid)
        } else {
          fetchexamdata(id)
        }   
      }, [location.search]);
      
      const fetchexamdata = async (id, appointmentid) => {
        showLoader()
            try {
              const result = await FetchPhysicalExamDetails({
                patientid: id,
                appointmentid: appointmentid,
              });
    
              if (result != null) {
                console.log(result,'chekc phyiscla ka data')
                setPhysicalExamData(result);
              } else {
                setPhysicalExamData('')
              }
              dismissLoader()
          } catch (error) {
              console.error("Error in home:", error);
            }
          };
    
          const formatDate = (dateString) => {
            // console.log(dateString, "date string")
            if (!dateString) return "-";
            return moment(dateString).format("Do MMM, YYYY");
          };
    
          // console.log(patientid, "physical exam IDDDDD")
          // console.log(physicalExamData, "physical exam Dataaaaaaa")
// const [isAddModalOpen, setIsAddModalOpen] = useState(false);
//   const [isEditModalOpen, setIsEditModalOpen] = useState(false);
          
      const addData = () => {
        setFormInputs([{ type: null, physicalexamtext: "", id: null, updateddate: "" }]);
        setDate(moment().format("DD-MM-yyyy"));
        setTime(moment().format("HH:mm"));
        setDefaultDoctor(null);
        setDoctorList([]);
        // setValue("textField", "", {
        //   shouldValidate: true,
        //   shouldDirty: true,
        // })
        setPlaceholder("Click anywhere to start typing....")
  setValue("textField", ""); // Clear the form value
  setAddHPIText('')
        fetchDoctors(true);
        // setIsAddModalOpen(true);
        addPhysicalRef.current.openModal();
      }

      // Add this helper function
      const [doctorExperience, setDoctorExperience] = useState("");
const getDoctorSpecialties = (doctor) => {
  if (!doctor || !doctor.doctorspeciality || doctor.doctorspeciality.length === 0) {
    return "";
  }
  
  const specialties = doctor.doctorspeciality.map(speciality => {
    if (speciality.specialityname === "Other" && speciality.othervalue) {
      return speciality.othervalue;
    }
    return speciality.specialityname;
  });
  
  return specialties.join(", ");
};
// Update the getDoctorSpecialties function to also handle experience
const getDoctorDetails = (doctor) => {
  if (!doctor) return { specialties: "", experience: "" };
  
  // Get specialties
  const specialties = getDoctorSpecialties(doctor);
  
  // Get experience
  const experience = doctor.experience || "";
  
  return { specialties, experience };
};
      const fetchDoctors = async (shouldSetDefault = false) => {
        showLoader();
        try {
          const result = await FetchUsersByClinic({
            doctorId,
            appointmentid
          });
          if (result.output.result == "success") {
            const doctors = result.output.data;
            setDoctorData(doctors);
            const doctorNames = doctors.map((step) => step.fullname);
            setDoctorList(doctorNames);

             if (shouldSetDefault) {
        const currentDoctor = doctors.find(doc => doc.doctorid == doctorId);
        if (currentDoctor) {
          // Add specialties and experience to the doctor object
          const doctorDetails = getDoctorDetails(currentDoctor);
          const doctorWithDetails = {
            ...currentDoctor,
            specialties: doctorDetails.specialties,
            experience: doctorDetails.experience
          };
          setDefaultDoctor(doctorWithDetails);
          // Also set doctorExperience state separately if needed
          setDoctorExperience(doctorDetails.experience);
          console.log("Default doctor has been set:", doctorWithDetails);
        } else {
          console.log("Could not find the current doctor in the fetched list.", currentDoctor);
        }
      }
            // setDoctorData(result.output.data);
            // const Doctors = result.output.data && result.output.data.map((step) => [
            //   step.fullname
            // ]);
            // setDoctorList(Doctors)
          } else {
            setDoctorList([]);
            dismissLoader();
          }
          dismissLoader();
        } catch (error) {
          console.error("Error", error);
        }
      };

      const HandleEditDoctor = (selectedOption)=>{
        // let selectedDoctor = doctorData.filter(doctor => doctor.fullname == selectedOption);
        let selectedDoctor = doctorData.find(doctor => doctor.fullname == selectedOption);
        if (selectedDoctor) {
  const doctorDetails = getDoctorDetails(selectedDoctor);
    const doctorWithDetails = {
      ...selectedDoctor,
      specialties: doctorDetails.specialties,
      experience: doctorDetails.experience
    };
    setDefaultDoctor(doctorWithDetails);
    // Also update doctorExperience state when doctor changes
    setDoctorExperience(doctorDetails.experience);
  } else {
    setDefaultDoctor(null);
    setDoctorExperience("")
  }
        // if (selectedDoctor.length > 0) {
        //   setDefaultDoctor(selectedDoctor[0]);
        // } else {
        //   setDefaultDoctor(null);
        // }
      }

      const handledatechange = (selectedDate) => {
        // setIsDateChanged(true)
        // const formattedDate = format(selectedDate, "yyyy-MM-dd");
        const formattedDate = moment(selectedDate).format("DD-MM-yyyy");
        setDate(formattedDate);
      };
    
      const handleTimeChange = (event) => {
        const inputTime = event.target.value;
        const currentDate = moment().format("DD-MM-yyyy");
        const currentTime = moment().format("HH:mm");
        
        // Only validate if the selected date is today
        if (date === currentDate) {
          const [inputHours, inputMinutes] = inputTime.split(":").map(Number);
          const [currentHours, currentMinutes] = currentTime.split(":").map(Number);
      
          // Create moment objects for comparison
          const inputMoment = moment().set({
            hour: inputHours,
            minute: inputMinutes,
            second: 0,
            millisecond: 0
          });
          
          const currentMoment = moment();
      
          if (inputMoment.isAfter(currentMoment)) {
            setTime(currentTime);
            showErrorToast("Future time cannot be selected.");
            return;
          }
        }
        
        // If date is not today or time is not in future, update the time
        setTime(inputTime);
      };
      
      const handleEditTimeChange = (event) => {
        const inputTime = event.target.value;
        const currentDate = moment().format("DD-MM-yyyy");
        const currentTime = moment().format("HH:mm");
        
        // Only validate if the selected date in edit modal is today
        if (date === currentDate) {
          const [inputHours, inputMinutes] = inputTime.split(":").map(Number);
          const [currentHours, currentMinutes] = currentTime.split(":").map(Number);
      
          // Create moment objects for comparison
          const inputMoment = moment().set({
            hour: inputHours,
            minute: inputMinutes,
            second: 0,
            millisecond: 0
          });
          
          const currentMoment = moment();
      
          if (inputMoment.isAfter(currentMoment)) {
            const currentFormattedTime = moment().format("HH:mm");
            setTime(currentFormattedTime);
            // setEditHPIData(prev => ({...prev, time: currentFormattedTime}));
            showErrorToast("Future time cannot be selected.");
            return;
          }
        }
        
        // If date is not today or time is not in future, update the time
        setTime(inputTime);
      };

      // const handleTimeChange = (event) => {
      //   const inputTime = event.target.value;
      //   console.log(inputTime, "input time");
      //   const currentTime = new Date();
      
      //   const inputDate = new Date();
      
      //   if (inputDate > currentTime) {
          
      //     setTime(moment().format("HH:mm"));
      //     showErrorToast("Future time cannot be selected.");
      //   } else {
      //     setTime(moment().format(inputTime,"HH:mm"));
      //   }
      // };

      const handleInputChange = (index, field, value) => {
        const newFormInputs = [...formInputs];
        newFormInputs[index][field] = value;
        setFormInputs(newFormInputs);
      };

      const getLocalISOString = (dateStr, timeStr) => {
    // Parse the date in DD-MM-yyyy format
    const [day, month, year] = dateStr.split("-").map(Number);
    // Parse the time in HH:mm format
    const [hours, minutes] = timeStr.split(":").map(Number);
    
    // Create a Date object in local timezone
    const dateObj = new Date(year, month - 1, day, hours, minutes, 0);
    
    // Format to ISO string with local timezone offset
    const timezoneOffset = dateObj.getTimezoneOffset() * 60000; // offset in milliseconds
    const localISOTime = new Date(dateObj - timezoneOffset).toISOString().slice(0, 19).replace('Z', '');
    
    return localISOTime;
  };
  const handleSavePhysicalExam = async () => {
    console.log(date, 'check state date')
     var formattedDate;
    //  if(!isDateChanged){
    //    formattedDate = moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
    //  }else {
    //     formattedDate = date
    //  }
    console.log(formattedDate, 'check formattedDate')
    let input = {
      doctorid: doctorId,
      patientid: patientid,
      appointmentid: appointmentid,
      // updateddate: `${formattedDate}T${time}:00`,
      updateddate: getLocalISOString(date, time),
      physicalexamtext: [{
        type: "other",
        description: addHPIText,
        id: null,
        updateddate: `${formattedDate}T${time}:00`,
        updateddate: getLocalISOString(date, time),
        updatedby: DefaultDoctor?.doctorid,
      }]
    }
    showLoader()
    try {
      const req = await UpdatePhysicalExam(input)
      if (req.output.result === "success") {
        if(appointmentid){
          fetchexamdata(patientid, appointmentid);
        } else {
          fetchexamdata(patientid);
        }
        showSuccessToast("Assessment saved successfully.");
        addPhysicalRef.current.closeModal();
        // setIsAddModalOpen(false)
        setFormInputs([{ type: null, physicalexamtext: "", id: null, updateddate: "" }]);
        setDate(moment().format("DD-MM-yyyy"));
        setTime(moment().format("HH:mm"));
        setDefaultDoctor(null);
        setDoctorList([]);
      } 
    } catch (error){
      console.error("Error saving physical exam:", error);
    } finally {
      dismissLoader();
    }
  }
  
  const handleEditPhysicalExam = async () => {
    // const formattedDate = moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
    var formattedDate;
    //  if(!isDateChanged){
    //    formattedDate = moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
    //  }else {
    //     formattedDate = date
    //  }
     if (!editHPIText || editHPIText.trim() === "") {
    showErrorToast("Please enter Physical exam text");
    return;
  }
    let updatedById;
    if (typeof DefaultDoctor === 'string') {
      const doctor = doctorData.find(d => d.fullname === DefaultDoctor);
      if (doctor) {
        updatedById = doctor.doctorid;
      }
    } else {
      updatedById = DefaultDoctor?.doctorid;
    }
    let input = {
      doctorid: doctorId,
      patientid: patientid,
      appointmentid: appointmentid,
      // updateddate: `${formattedDate}T${time}:00`,
      updateddate: getLocalISOString(date, time),
      physicalexamtext: [{
        updatedby: updatedById,
        type: "other",
        // description: addHPIText,
        description: editHPIText,
        id: formInputs[0].id,
        // updateddate: `${formattedDate}T${time}`,
        updateddate: getLocalISOString(date, time),
      }]
    }

    console.log(input, 'check input for physical exam')
    showLoader()
    try {
      const req = await UpdatePhysicalExam(input)
      if (req.output.result === "success") {
        if(appointmentid){
          fetchexamdata(patientid, appointmentid);
        } else {
          fetchexamdata(patientid);
        }
        showSuccessToast("Assessment saved successfully.");
        setFormInputs([{ type: null, physicalexamtext: "", id: null, updateddate: "" }]);
        setDate(moment().format("DD-MM-yyyy"));
        setTime(moment().format("HH:mm"));
        setDefaultDoctor(null);
        setDoctorList([]);
        setIsDateChanged(false);
        editPhysicalRef.current.closeModal();
  // setIsEditModalOpen(false)

      } else {
        showErrorToast("Failed to save assessment.");
      }
    } catch (error){

    } finally {
      dismissLoader();
    }
  }

      
  var [DoctorList, setDoctorList] = useState([]);
  var [DefaultDoctor, setDefaultDoctor] = useState(null);
  const [addHPIText, setAddHPIText] = useState('')
  const [editHPIText, setEditHPIText] = useState('')
  const [hpiTextBox, SetHPITextBox] = useState('')

  const { register, handleSubmit, watch, setValue } = useForm();
  const textFieldValue = watch("textField", "");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [initialText, setInitialText] = useState("");


  // useEffect(() => {
  //     const out = activeTranscriber?.output?.text;
  //     if (!out) return;
  
  //     // put transcription into the modal currently open
  //     setValue("textField", out);
  //     setPlaceholder("");
  //     setTyping(false);
  
  //     if (isAddModalOpen) {
  //       setAddHPIText(out);
  //     } else if (isEditModalOpen) {
  //       setEditHPIText(out);
  //     } else {
  //       // fallback: update add field
  //       setAddHPIText(out);
  //     }
  //   }, [activeTranscriber?.output, isAddModalOpen, isEditModalOpen, setValue]);

  useEffect(() => {
    if (activeTranscriber?.output?.text) {
  const transcribedText = activeTranscriber.output.text;
  setValue("textField", transcribedText);
  // setAddGeneralDoctorNotes(transcribedText); // Update the state with transcribed text
  // setPlaceholder("Click anywhere to start typing...."); // Clear the placeholder when text exists
  setAddHPIText(transcribedText); // Add this line to update addHPIText state
    setPlaceholder("");
  setTyping(false);
}
    }, [activeTranscriber?.output]);

    // Handle text changes in the textarea
const handleTextChange = (e) => {
  const text = e.target.value;
  setAddHPIText(text);
  setValue("textField", text); // Keep form value in sync
  setPlaceholder(text ? "" : "Click anywhere to start typing...."); // Show placeholder only when empty
};
const handleEditTextChange = (e) => {
    const text = e.target.value;
    setEditHPIText(text);
    setValue("textField", text); // Keep form value in sync
    setPlaceholder(text ? "" : "Click anywhere to start typing...."); // Show placeholder only when empty
  };

  const onSubmit = (data) => {
      setIsButtonDisabled(true); // Disable button on submit
      // UpdateHpiTextBox(data);
      SetHPITextBox(data);
      // fetchDoctorNotesEmptyIndication();
    };
  
      // submit on tab switch and submit button is enalbed
      useEffect(()=>{
          if(!isButtonDisabled){
          handleSubmit(onSubmit)();
          }
      },[])
  
    useEffect(() => {
      if (textFieldValue !== initialText) {
        setIsButtonDisabled(false); // Enable button if text field value changes
      } else {
        setIsButtonDisabled(true); // Disable button if text field value is unchanged
      }
    }, [textFieldValue, initialText]);

    const correctOrders = async (formType) => {
        const currentText = watch("textField");
        console.log(formType, 'check form type')
        if (!currentText) {
          showErrorToast("No text available to correct");
          return;
        }

        // Include doctor specialties in the AI correction request
  const doctorSpecialties = DefaultDoctor?.specialties || "";
    
        // const inputToSave = {
        //   input: {
        //     text: currentText,
        //   },
        // };
        console.log('physcialexam specialitey', doctorSpecialties)
        const inputToSave = {
          input: {
            text: currentText,
            // type: `physical_exam#${doctorSpecialties}#${doctorExperience}#Consultation Note#${outLang}#${inpLang}`,
//             type: `physical_exam
// #${doctorSpecialties}#${noteType}#${doctorExperience}#${inpLang}#${outLang}`,
            type: "Physical Exam"
          },
        };
    
        showLoader();
        try {
          // const result = await CorrectChiefComplaintUsingAI(inputToSave.input);
          const result = await CorrectMedicalTermsUsingAI(inputToSave);
          if (result) {
            showSuccessToast("Updated Text");
            const updatedText = result?.text;
    
            // Update form value
            setValue("textField", updatedText, {
              shouldDirty: true,
              shouldTouch: true,
              shouldValidate: true,
            });
                
            // Update the appropriate state based on form type
            if (formType === "add") {
              setAddHPIText(updatedText);
            } else {
              // handleEditMedicineChange("custommessage", updatedText);
              setEditHPIText(updatedText);
            }
            
             setPlaceholder("");
            setIsButtonDisabled(false);
          }
        } catch (error) {
          console.error("Error in Correct AI call:", error);
          // showErrorToast("Error Happened While Correcting.");
          showErrorToast("Error in Correct AI call.");
        } finally {
          dismissLoader();
        }
    };

    const handleEdit = (physicalexam) => {
      console.log(physicalexam, 'check physical exam data for edit')
      // setValue("textField", physicalexam.physicalexamtext, {
      //   shouldValidate: true,
      //   shouldDirty: true,
      // });
      setValue("textField", physicalexam.physicalexamtext || "");
  setEditHPIText(physicalexam.physicalexamtext || "");
  setPlaceholder(physicalexam.physicalexamtext ? "" : "Click anywhere to start typing....");

  // Find the doctor from doctorData and get their specialties
    // const doctorFromData = doctorData.find(doc => doc.doctorid == physicalexam.doctorid);
    // const doctorWithSpecialties = doctorFromData ? {
    //   ...doctorFromData,
    //   specialties: getDoctorSpecialties(doctorFromData)
    // } : { fullname: physicalexam.doctorname, specialties: "" };
    const doctorFromData = doctorData.find(doc => doc.doctorid == physicalexam.doctorid);
    const doctorDetails = getDoctorDetails(doctorFromData);
    const doctorWithDetails = doctorFromData ? {
      ...doctorFromData,
      specialties: doctorDetails.specialties,
      experience: doctorDetails.experience
    } : { 
      fullname: physicalexam.doctorname, 
      specialties: "",
      experience: "" 
    };
      
    setDefaultDoctor(doctorWithDetails);
    setDoctorExperience(doctorDetails.experience);
    // setDefaultDoctor(doctorWithSpecialties);
      // setDefaultDoctor(physicalexam.doctorname);
      setDate(moment(physicalexam.updateddate).format("DD-MM-yyyy"));
      setTime(moment(physicalexam.updateddate).format("HH:mm:ss"));
      setFormInputs([
        {
          type: physicalexam.type,
          physicalexamtext: physicalexam.physicalexamtext,
          id: physicalexam.id,
          updateddate: physicalexam.updateddate,
        },
      ]);
  // setIsEditModalOpen(true)
      fetchDoctors()
      editPhysicalRef.current.openModal();
    };

    const openDeleteModal = (id) => {
      setDeleteId(id);
      deletePhysicalRef.current.openModal();
    };

    const handleConfirmDelete = async () => {
      if (!deleteId) return;
    
      const input = {
        doctorid: doctorId,
        patientid: patientid,
        appointmentid: appointmentid,
        id: deleteId,
        isactive: 0,
      };

      showLoader();
      try {
        const req = await UpdatePhysicalExam(input);
        if (req.output.result === "success") {
          if (appointmentid) {
            await fetchexamdata(patientid, appointmentid);
          } else {
            await fetchexamdata(patientid);
          }
          showSuccessToast("Physical Exam deleted successfully.");
          deletePhysicalRef.current.closeModal();
          setDeleteId(null);
        } else {
          showErrorToast("Failed to delete Physical Exam.");
        }
      } catch (error) {
        console.error("Error deleting Physical Exam:", error);
        showErrorToast("Error deleting the Physical Exam.");
      } finally {
        dismissLoader();
      }
    };

      return (
        <>
        {isLoading && <Loader />}
        {screenType == 'web' ? (
          <Box w="100%">
            {appointmentid && (
              <Box pos='sticky' p='1rem 1.5rem' alignItems='center' top='0' zIndex='999' bg='white' borderBottom='1px solid #E6E7E9' display="flex" justifyContent="space-between" mb="10px">
                <Text fontWeight='600'>Physical Exam</Text>
                <PrimaryButton
                  fontSize="14px"
                  variant="mdBtn"
                  btnIcon="/assets/imgs/add.png"
                  buttonText="Add Data"
                  onClick={addData}
                  // isDisabled={actionAccessPatients?.create ? false : true}
                />
              </Box>
            )}
            <Stepper
              orientation="vertical"
              height='calc(100vh - 160px)'
              overflow='hidden auto'
              padding='1rem'
              size="xs"
              colorScheme="#CDCFD4"
              gap="1rem"
              w="100%"
              justifyContent='flex-start'
            >
              {physicalExamData && physicalExamData.length>0 ? (
                physicalExamData.map((exam,index) => (
                  // exam.physicalexam || exam.physicalexamtext && 
                <Step key={index} flex='unset' w="100%" >
                  <StepIndicator color="#E6E7E9" />
    
                  <Box flexShrink="0" w="95%">
                    {/* <StepTitle fontSize="0.75rem" fontWeight="500" color="#384052" mb="0.5rem">
                      {exam.Date ? formatDate(exam.Date) : '-'}
                    </StepTitle> */}
                    <StepTitle as="div">
                    {/* <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{moment(exam.updateddate).format('DD-MM-yyyy')}</Text> */}
                    {appointmentid ? (
                      <Flex justifyContent='space-between' >
                        <Box display='flex' alignItems='center' gap='10px'>
                          <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">
                            {
                              exam.updateddate ? formatDate(exam.updateddate) : formatDate(exam.DATE)
                            } 
                          </Text> 
                          <Box fontSize='10px' bg={exam.iscurrentvisit === 1 ? '#10b981' : '#d69e2e'} color='white' mb="0.5rem" p='0.25rem 0.5REM' borderRadius='6px'>{exam.iscurrentvisit === 1 ? 'CURRENT' : 'PAST'}</Box>
                        </Box>
                      </Flex>
                    ) : (
                      <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{formatDate(exam.DATE)}</Text>
                    )}
                    <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{`${exam.doctorname} , ${exam.bookingid}`}</Text>
                    <Text fontSize="0.875rem" color="#384052" mb="0.5rem">{exam.specialization}</Text>
                  </StepTitle>
                    <StepDescription
                      bg="white"
                      w="100%"
                      border="1px solid #E6E7E9"
                      borderRadius="0.65rem"
                      p="0.75rem"
                      mb="1.5rem"
                      boxShadow="0px 8px 20px 0px #E6E7E966"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Box w="fit-content" display="flex" gap="0.5rem" flexWrap='wrap' className="textOverflow">
                        <Text fontSize="0.625rem" w="max-content" fontWeight="600" color="#384052" p="0.25rem 0.5rem" bg="#E6E7E966" border="1px solid #E6E7E9" borderRadius="full">
                          {/* Constitutional */}
                          {exam && exam?.type}
                        </Text>

                        {/* {exam.type === "other" ? (
                          <Text fontSize="0.875rem" color="#061027">
                              {exam?.physicalexamtext ? exam?.physicalexamtext : '-'}
                            </Text>
                        ) : (
                          exam && exam?.physicalexam?.length > 0 && (
                            <Text fontSize="0.875rem" color="#061027">
                              {exam?.physicalexam
                                .map(item => item.examvalue) 
                                .join(', ')} 
                            </Text>
                            )

                        )} */}

                        {Array.isArray(exam.physicalexam) && exam.physicalexam.length > 0 ? (
  <Text fontSize="0.875rem" color="#061027">
    {exam.physicalexam
      .map(item => item.examvalue)
      .filter(Boolean)
      .join(', ') || '-'}
  </Text>
) : (
  <Text fontSize="0.875rem" color="#061027">
    {exam?.physicalexamtext ? exam.physicalexamtext : '-'}
  </Text>
)}


                        {/* {exam && exam.physicalexam.length > 0 ? (
                          exam.physicalexam.map((item,subIndex) => (
                        <Text fontSize="0.875rem" color="#061027" key={subIndex}>
                          {item.value ? (item.value +",") : ('')}
                        </Text>
                          ))
                        ) : ('-')} */}
                      </Box>
                      {exam.iscurrentvisit === 1 && (
                        <HStack>
                          <Box
                            as="button"
                            onClick={() => handleEdit(exam)} 
                            bg='white'
                            border="1px solid #E6E7E9"
                            borderRadius="full"
                            w="36px"
                            h="auto"
                            p="10px"
                            >
                            <Image w="13px" src="/assets/imgs/edit-gray.png" />
                          </Box>
                          <Box
                            as="button"
                            onClick={() => openDeleteModal(exam.id)}
                            bg="white"
                            border="1px solid #E6E7E9"
                            borderRadius="full"
                            w="36px"
                            h="auto"
                            p="10px"
                          >
                            <Image w="13px" src="/assets/svgs/delete.svg" />
                          </Box>
                        </HStack>
                        // <Box
                        //   as="button"
                        //   onClick={() => handleEdit(exam)} 
                        //   bg='white'
                        //   border="1px solid #E6E7E9"
                        //   borderRadius="full"
                        //   w="36px"
                        //   h="auto"
                        //   p="10px"
                        //   >
                        //   <Image w="13px" src="/assets/imgs/edit-gray.png" />
                        // </Box>
                      )}
                    </StepDescription>
                  </Box>
    
                  <StepSeparator colorScheme="red" />
                </Step>

                ))
              ) : (
                <Box
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            gap="10px"
                            alignItems="center"
                            h="calc(100vh - 100px)"
                            w="100%"
                          >
                            <Box textAlign="left" fontSize="16px" fontWeight="600">
                              <Image
                                w="26px"
                                opacity="0.5"
                                src="/assets/imgs/physical-exam.png"
                              />
                            </Box>
                            <Text textAlign="left" fontSize="12px" fontWeight="500">
                              No Data available
                            </Text>
                          </Box>
              )}
            </Stepper>
          </Box>
        ) : (
        //Mobile responsive
        <Box w="100%">
          <MobileSecondaryNav
            header="Physical exam"
            handlebackarrow={backFunction}
          />

          <Box w="100%" h="calc(100vh - 120px)" overflow='hidden auto' p="1rem">
          <Stepper
              orientation="vertical"
              height="100%"
              size="xs"
              colorScheme="#CDCFD4"
              gap="0"
              w="100%"
            >
              {physicalExamData && physicalExamData.length>0 ? (
                physicalExamData.map((exam,index) => (
                <Step key={index} w="100%" >
                  <StepIndicator color="#E6E7E9" />
    
                  <Box flexShrink="0" w="95%">
                    {/* <StepTitle fontSize="0.75rem" fontWeight="500" color="#384052" mb="0.5rem">
                      {exam.Date ? formatDate(exam.Date) : '-'}
                    </StepTitle> */}
                    <StepTitle as="div">
                    <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{moment(exam.updateddate).format('DD-MM-yyyy')}</Text>
                    <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{`${exam.doctorname} , ${exam.bookingid}`}</Text>
                    <Text fontSize="0.875rem" color="#384052" mb="0.5rem">{exam.specialization}</Text>
                  </StepTitle>
                    <StepDescription
                      bg="white"
                      w="100%"
                      border="1px solid #E6E7E9"
                      borderRadius="0.65rem"
                      p="0.75rem"
                      mb="1.5rem"
                      boxShadow="0px 8px 20px 0px #E6E7E966"
                    >
                      <Box w="fit-content" display="flex" flexDir='column' gap="0.5rem" className="textOverflow">
                        <Text fontSize="0.625rem" w="max-content" fontWeight="600" color="#384052" p="0.25rem 0.5rem" bg="#E6E7E966" border="1px solid #E6E7E9" borderRadius="full">
                          {/* Constitutional */}
                          {exam && exam?.type}
                        </Text>
                        {exam && exam?.physicalexam?.length > 0 ? (
                        <Box display='flex' flexDir='column'>
                          {exam?.physicalexam.map((item,subIndex) => (
                        <Text fontSize="0.875rem" color="#061027" key={subIndex}>
                          {/* Chills, Fever and Fatigue */}
                          {item.value},
                        </Text>

                        ))}
                        </Box>
                        ) : ('-')}
                      </Box>
                    </StepDescription>
                  </Box>
    
                  <StepSeparator colorScheme="red" />
                </Step>

                ))
              ) : (
                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  gap="10px"
                  alignItems="center"
                  h="calc(100vh - 100px)"
                  w="100%"
                >
                  <Box textAlign="left" fontSize="16px" fontWeight="600">
                    <Image
                      w="26px"
                      opacity="0.5"
                      src="/assets/imgs/physical-exam.png"
                    />
                  </Box>
                  <Text textAlign="left" fontSize="12px" fontWeight="500">
                    No Data available
                  </Text>
                </Box>
              )}
            </Stepper>
          </Box>
        </Box>
      )}

      <DynamicModal
        ref={addPhysicalRef}
        modalWidth={"40vw"}
        footerStyle={{ p: "0.5rem 1rem" }}
        modalHeight="auto"
        modalHeader="Add Physical Exam"
        modalBody={
          <>
            <Flex flexDir='column'>
              <Flex>
                <DropdownInput
                  variant="leftSide"
                  dropDownPlace="Doctor Name"
                  options={DoctorList}
                  id="Doctor Name"
                  onClick={HandleEditDoctor}
                  value={DefaultDoctor?.fullname} 
                  inputValue={DefaultDoctor?.fullname}
                  menuList={{ pos: "absolute", right: "-41px", minW: "310px" }}
                  inputStyleCss={{w: "100%"}}
                />
                <Box display="flex" flexDir="row" w="100%">
                  <DatePicker
                    onDateChange={(selectedDateValue) =>
                      handledatechange(selectedDateValue)
                    }
                    defaultDate={date}
                    disableFutureDates={true}
                    placeholderProp="Date"
                    calendarStlye={{left: "-18px",  right: "unset"}}
                    datePickerInputStyle={{borderRadius: '0'}}
                  />

                  <PrimaryInput
                    variant="rightSide"
                    id="vitaltime"
                    inputType="time"
                    inputPlace="Time"
                    pr="10px"
                    defaultValue={time}
                    inputValue={time}
                    onChange={handleTimeChange}
                  />
                </Box>
              </Flex>

              {/* <Textarea
                borderRadius='0'
                name="doctorsassessment[0].plan" 
                value={formInputs[0].plan} 
                onChange={(e) => handleInputChange(0, "plan", e.target.value)}
                height="100%"
                placeholder="Physical Exam"
                padding="2"
                resize="none"
                disabled={placeholder}
                style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
              /> */}

              <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>
                <Box
                  as="form"
                  width='100%'
                  bg="white"
                >
                  <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
                    <Textarea
                      borderRadius='0'
                      // placeholder="Instructions"
                      {...register("textField")}
                      // inputValue={addHPIText}
                      value={addHPIText}
                      onChange={handleTextChange}
                      height="100%"
                      padding="2"
                      resize="none"
                      // disabled={typing} // Disable when AI typing is true
                      style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
                    />
                    
                    {!addHPIText && (
                      <Text
                        position="absolute"
                        bottom="2"
                        left="50%"
                        transform="translateX(-50%)"
                        fontSize="sm"
                        color="gray.500"
                        w={{ base: "100%", md: "unset" }}
                        textAlign={{ base: "center", md: "unset" }}
                      >
                        {placeholder}
                      </Text>
                    )}
                  </Box>
                </Box>
              </Box>
            </Flex>
          </>
        }

        modalFooterBtn={
          <HStack
            p={2}
            bottom="0"
            width="100%"
            alignItems='center'
          >
          {/* <Box w='25%'>
                  <DropdownWithMultiLingual 
                    menuList={{pos:'relative', right:'75px'}}
                    placeholder="English"
                    // onClick={(e) => handleChangeLanguage(e)}
                    onClick={handleChangeLanguage}
                    options={languageOptions.map(value => ({ value }))}
                    title="Input Language"
                  />
                  </Box> */}

            <GPUChatAudioManagerSpeechMode
                  transcriber={activeTranscriber}
                  mode={mode}
                  setPlaceholder={setPlaceholder}
                  setTyping={setTyping}
                  // onRecordingStateChange={handleRecordingStateChange} 
                />

            {/* {isRecording && (
                      <AudioDisplayForClutter
                        mx="auto"
                        borderRadius="lg"
                        stream={stream}
                      />
                    )}
                    <Box w='25%'>
                    <DropdownWithMultiLingual 
                      menuList={{pos:'relative', right:'75px'}}
                      placeholder="English"
                      // onClick={(e) => handleChangeLanguage(e)}
                      onClick={handleChangeOutputLanguage}
                      options={languageOptions.map(value => ({ value }))}
                      title="Output Language"
                    />
                    </Box> */}

            <Box
              as="button"
              type="button" // Prevent form submission
              border="1px solid #E6E7E9"
              borderRadius="full"
              w="36px"
              h="auto"
              p="10px"
              mr='10px'
              display="flex"
              justifyContent="center"
              alignItems="center"
              // cursor={textFieldValue || addHPIText ? "pointer" : "not-allowed"}
              // opacity={textFieldValue || addHPIText ? 1 : 0.5}
              // pointerEvents={textFieldValue || addHPIText ? "auto" : "none"}
              // onClick={() => textFieldValue || addHPIText && correctOrders("add")}
              cursor={textFieldValue ? "pointer" : "not-allowed"}
              opacity={textFieldValue ? 1 : 0.5}
              pointerEvents={textFieldValue ? "auto" : "none"}
              onClick={() => textFieldValue && correctOrders("add")}
            >
              <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
            </Box>

            <PrimaryButton
              buttonText="Save Physical Exam"
              onClick={handleSavePhysicalExam}
              variant='mdBtn'
              btnStyle={{w: "100%"}}
            />    
          </HStack>
        }
      />
      
      <DynamicModal
        ref={editPhysicalRef}
        modalWidth={"40vw"}
        footerStyle={{ p: "0.5rem 1rem" }}
        modalHeight="auto"
        modalHeader="Edit Physical Exam"
        modalBody={
          <>
            <Flex flexDir='column'>
              <Flex>
                <DropdownInput
                  variant="leftSide"
                  dropDownPlace="Doctor Name"
                  options={DoctorList}
                  id="Doctor Name"
                  onClick={HandleEditDoctor}
                  // value={DefaultDoctor?.fullname ?? DefaultDoctor} 
                  value={DefaultDoctor?.fullname || ""} 
                  // defaultOption={DefaultDoctor}
                  menuList={{ pos: "absolute", right: "-41px", minW: "310px" }}
                  inputStyleCss={{w: "100%"}}
                />
                <Box display="flex" flexDir="row" w="100%">
                  <DatePicker
                    onDateChange={(selectedDateValue) =>
                      handledatechange(selectedDateValue)
                    }
                    defaultDate={date}
                    disableFutureDates={true}
                    placeholderProp="Date"
                    calendarStlye={{left: "-18px",  right: "unset"}}
                    datePickerInputStyle={{borderRadius: '0'}}
                  />

                  <PrimaryInput
                    variant="rightSide"
                    id="vitaltime"
                    inputType="time"
                    inputPlace="Time"
                    pr="10px"
                    defaultValue={time}
                    inputValue={time}
                    onChange={handleTimeChange}
                    // onChange={handleEditTimeChange}
                  />
                </Box>
              </Flex>

              {/* <Textarea
                borderRadius='0'
                name="doctorsassessment[0].plan" 
                value={formInputs[0].plan} 
                onChange={(e) => handleInputChange(0, "plan", e.target.value)}
                height="100%"
                placeholder="Physical Exam"
                padding="2"
                resize="none"
                disabled={placeholder}
                style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
              /> */}

              <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>
                <Box
                  as="form"
                  width='100%'
                  bg="white"
                >
                  <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
                    <Textarea
                      borderRadius='0'
                      // placeholder="Instructions"
                      {...register("textField")}
                      // inputValue={formInputs[0].physicalexamtext}
                      // value={updateCC}
                      inputValue={editHPIText}
                      // onChange={handleTextChange}
                      onChange={handleEditTextChange}
                      height="100%"
                      padding="2"
                      resize="none"
                      // disabled={typing} // Disable when AI typing is true
                      style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
                    />
                    
                    {!editHPIText && (
                      <Text
                        position="absolute"
                        bottom="2"
                        left="50%"
                        transform="translateX(-50%)"
                        fontSize="sm"
                        color="gray.500"
                        w={{ base: "100%", md: "unset" }}
                        textAlign={{ base: "center", md: "unset" }}
                      >
                        {placeholder}
                      </Text>
                    )}
                  </Box>
                </Box>
              </Box>
            </Flex>
          </>
        }

        modalFooterBtn={
          <HStack
            p={2}
            bottom="0"
            width="100%"
            alignItems='center'
          >
            {/* <Box w='25%'>
                    <DropdownWithMultiLingual 
                      menuList={{pos:'relative', right:'75px'}}
                      placeholder="English"
                      // onClick={(e) => handleChangeLanguage(e)}
                      onClick={handleChangeLanguage}
                      options={languageOptions.map(value => ({ value }))}
                      title="Input Language"
                    />
                    </Box> */}

           <GPUChatAudioManagerSpeechMode
                  transcriber={activeTranscriber}
                  mode={mode}
                  setPlaceholder={setPlaceholder}
                  setTyping={setTyping}
                  // onRecordingStateChange={handleRecordingStateChange} 
                />

                {/* {isRecording && (
                          <AudioDisplayForClutter
                            mx="auto"
                            borderRadius="lg"
                            stream={stream}
                          />
                        )}
                        <Box w='25%'>
                        <DropdownWithMultiLingual 
                          menuList={{pos:'relative', right:'75px'}}
                          placeholder="English"
                          // onClick={(e) => handleChangeLanguage(e)}
                          onClick={handleChangeOutputLanguage}
                          options={languageOptions.map(value => ({ value }))}
                          title="Output Language"
                        />
                        </Box> */}
            <Box
              as="button"
              type="button" // Prevent form submission
              border="1px solid #E6E7E9"
              borderRadius="full"
              w="36px"
              h="auto"
              p="10px"
              mr='10px'
              display="flex"
              justifyContent="center"
              alignItems="center"
              // cursor={textFieldValue || addHPIText ? "pointer" : "not-allowed"}
              // opacity={textFieldValue || addHPIText ? 1 : 0.5}
              // pointerEvents={textFieldValue || addHPIText ? "auto" : "none"}
              // onClick={() => textFieldValue || addHPIText && correctOrders("add")}
              cursor={textFieldValue ? "pointer" : "not-allowed"}
              opacity={textFieldValue ? 1 : 0.5}
              pointerEvents={textFieldValue ? "auto" : "none"}
              onClick={() => textFieldValue && correctOrders("edit")}
            >
              <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
            </Box>

            <PrimaryButton
              buttonText="Save Physical Exam"
              onClick={handleEditPhysicalExam}
              variant='mdBtn'
              btnStyle={{w: "100%"}}
            />    
          </HStack>
        }
      />

      <DynamicModal
          ref={deletePhysicalRef}
          modalHeader="Delete Physical Exam?"
          modalBody={
            <Text fontSize="14px" fontWeight="600">
              Are you sure you want to delete this Physical Exam?
            </Text>
          }
          modalFooterBtn={
            <PrimaryButton
              buttonText="Delete"
              btnStyle={{
                w: "100%",
                h: "2.5rem",
              }}
              onClick={handleConfirmDelete}
            />
          }
        />
    </>
  );
}

export default PhysicalExam